import { Outcome } from "@siteimprove/alfa-act";
export function isPassed(outcome) {
    if (Outcome.isPassed(outcome)) {
        return true;
    }
    if (Outcome.isFailed(outcome)) {
        return false;
    }
    return undefined;
}
//# sourceMappingURL=is-passed.js.map